import React from 'react';
import jQuery from 'jquery';
import Configurator from './Configurator.jsx';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';
import styles from './ItkTenderConfigurator.styl';

/**
 * Тендерный калькулятор ITK
 * @see http://helpdesk.iek.local/Task/View/184272
 */
class ItkTenderConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			floorCount: '',
			portCount: '',
			cableCategory: '',
			cableShield: '',
			totalCost: 0,
			specList: [],
			variants: {}
		};

		this.onSpecListItemClick = this.onSpecListItemClick.bind(this);
		this.onChangeItemVariant = this.onChangeItemVariant.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		this.onBtnPrintClick = this.onBtnPrintClick.bind(this);
	}

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'itkTenderCalc';
	}

	getSectionItems(p = {}) {
		let items = [];
		let categories = [];

		for (let i = 0; i < this.db.list.length; i++)
		{
			let item = this.db.list[i];

			if (item.section !== p.section) {
				continue;
			}

			if (item.shield && item.shield !== p.state.cableShield) {
				continue;
			}

			if (item.category && item.category !== p.state.cableCategory) {
				continue;
			}

			const k = `${item.category}_${item.type}`;

			item = jQuery.extend(item, {
				count: p.count(item),
				variants: p.variants ? p.variants(item) : false,
				hidden: p.hidden ? p.hidden(item, categories.indexOf(k) === -1) : false,
			});

			if (categories.indexOf(k) === -1) {
				categories.push(k);
			}

			items.push(item);

			// Еще одна вентиляторная панель для настенного шкафа
			if (item.type === 'enclosure_wall' && !item.hidden) {
				for (let j = 0; j < items.length; j++) {
					let _item = items[j];
					if (_item.type === 'vent_panel' && !_item.hidden) {
						let __item = jQuery.extend({}, _item);
						delete __item.variants;
						__item.count = 1;
						items.push(__item);
						break;
					}
				}
			}
		}

		return items;
	}

	getItemVariants(_item, params) {
		const variants = [];

		for (let i = 0; i < this.db.list.length; i++)
		{
			let item = this.db.list[i];

			if (item.section !== _item.section) {
				continue;
			}

			if (item.shield && (item.shield !== _item.shield)) {
				continue;
			}

			if (item.category && (item.category !== _item.category)) {
				continue;
			}

			if (item.type && (item.type !== _item.type)) {
				continue;
			}

			if (item.for && params && params.enclosure && item.for.split(',').indexOf(params.enclosure) === -1) {
				continue;
			}

			const v = jQuery.extend({}, item);
			delete v.variants;

			variants.push(v);
		}

		return variants;
	}

	getItemByArticle(article) {
		for (let i = 0; i < this.db.list.length; i++) {
			let item = this.db.list[i];
			if (item.article === article) {
				return item;
			}
		}
		return null;
	}

	onFieldChange(name, e, article = null) {
		const stateCopy = JSON.parse(JSON.stringify(this.state));

		if (name) {
			let value = e.target ? e.target.value : e;

			switch (name) {
				case 'portCount':
					value = value === '' ? 0 : parseInt(value, 10);
					break;
			}

			stateCopy[name] = value;
		}

		stateCopy.totalCost = 0;
		stateCopy.specList = [];

		if ('variants' === name) {
			stateCopy.item = this.getItemByArticle(article);
		} else {
			stateCopy.item = null;
		}

		if (!stateCopy.portCount || !stateCopy.floorCount || !stateCopy.cableCategory || !stateCopy.cableShield)
		{
			this.setState(stateCopy);
			return;
		}

		stateCopy.specList.push({ name: '1. Оборудование рабочих мест' });
		stateCopy.specList.push(...this.getSectionItems({
			section: 1,
			state: stateCopy,
			count: item => item.type === 'frame2' ? Math.ceil(stateCopy.portCount / 2) : stateCopy.portCount
		}));

		stateCopy.specList.push({ name: '2. Оборудование распределительного узла' });

		let units = 42;
		if (stateCopy.variants.hasOwnProperty('2_enclosure'))
		{
			let regUnits = /-(\d+)U/.exec(stateCopy.variants['2_enclosure']);
			if (regUnits) {
				units = parseInt(regUnits[1], 10);
			}
		}

		const secItems = this.getSectionItems({
			section: 2,
			state: stateCopy,
			variants: item => ['enclosure', 'enclosure_wall', 'pdu', 'vent_panel', 'opt_cross', 'polka'].indexOf(item.type) !== -1 ? this.getItemVariants(item, {enclosure: stateCopy.variants['2_enclosure'] ? stateCopy.variants['2_enclosure'] : 'LN05-42U68-G'}) : false,
			hidden: (item, firstInCategory) => {
				const k = `${item.section}_${item.type}`;

				if (stateCopy.variants.hasOwnProperty(k)) {
					return stateCopy.variants[k] !== item.article;
				}

				return ['enclosure', 'enclosure_wall', 'pdu', 'vent_panel', 'opt_cross', 'polka'].indexOf(item.type) !== -1 && !firstInCategory;
			},
			count: item => {
				switch (item.type) {
					case 'enclosure':
					case 'polka':
					case 'vvod':
					case 'shina':
					case 'wires':
					case 'lpanel':
					case 'pdu':
						return Math.ceil((Math.ceil(stateCopy.portCount / units) + (2 * Math.ceil(stateCopy.portCount / units))) / units);
					case 'vent_panel':
						return Math.ceil((Math.ceil(stateCopy.portCount / units) + (2 * Math.ceil(stateCopy.portCount / units))) / units) * 2;
					case 'vint':
						return (Math.ceil((Math.ceil(stateCopy.portCount / units) + (2 * Math.ceil(stateCopy.portCount / units))) / units)) * 4
							+ Math.ceil(stateCopy.portCount / 24) * 2;
					case 'enclosure_wall':
					case 'opt_cross':
						return parseInt(stateCopy.floorCount, 10);
				}
				return 1;
			}
		});
		stateCopy.specList.push(...secItems);

		stateCopy.specList.push({ name: '3. Оборудование коммутационное' });
		stateCopy.specList.push(...this.getSectionItems({
			section: 3,
			state: stateCopy,
			count: item => item.type === 'patch_cord' ? stateCopy.portCount : Math.ceil(stateCopy.portCount / 24),
			variants: item => item.type === 'cable_organizer' ? this.getItemVariants(item) : false,
			hidden: (item, firstInCategory) => {
				const k = `${item.section}_${item.type}`;

				if (stateCopy.variants.hasOwnProperty(k)) {
					return stateCopy.variants[k] !== item.article;
				}

				return item.type === 'cable_organizer' && !firstInCategory;
			}
		}));

		stateCopy.specList.push({ name: '4. Кабели и провода' });
		stateCopy.specList.push(...this.getSectionItems({
			section: 4,
			state: stateCopy,
			count: () => Math.ceil(stateCopy.portCount * 50 / 305)
		}));


		for (let i = 0; i < stateCopy.specList.length; i++)
		{
			const item = stateCopy.specList[i];

			if (!item.price || item.hidden) {
				continue;
			}

			stateCopy.totalCost += item.price * item.count;
		}
    this.doAddToCart(stateCopy.specList)
		this.setState(stateCopy);
	}
	doAddToCart(items){
		const goods = JSON.stringify(
			{
				products: items.map(i => {
					if (i.count) {
						return {
							cnt: i.count || 1,
							art: i.article,
							name: i.name,
						}
					} else {
						return {
							category: i.name
						}
					}
				})
			}
		)
		console.log(goods);
		// Отправка JSON в ipro
		window.top.postMessage(goods, '*')
	}

	onSpecListItemClick(item) {
		super.onListItemCheck(item.article);
	}

	onChangeItemVariant(article, itemWithVariants) {
		const variants = jQuery.extend({}, this.state.variants);
		variants[`${itemWithVariants.section}_${itemWithVariants.type}`] = article;
		this.onFieldChange('variants', variants, article);
		super.onListItemCheck(article);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onStepDownload() {
		window.location = 'http://www.iek.ru/products/standard_solutions/download/ITK_STEP.rar';
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.state.specList),
			state: JSON.stringify(this.state)
		};

		super.doPrint(_params);
	}

	onBtnPrintClick() {
		this.doPrint();
	}


	render() {
		const customStyles = this.getCustomStyles();

		if (!this.db) {
			return <div className={customStyles.cfg} />;
		}

		return (
			<div className={customStyles.cfg}>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				<span className={styles.title}>Калькулятор СКС</span>

				<input className={customStyles.floorCount} value={this.state.floorCount <= 0 ? '' : this.state.floorCount} type="number"
					onChange={e => this.onFieldChange('floorCount', e)} />
				<span className={customStyles.floorCountLabel}>Количество этажей:</span>

				<input className={customStyles.portCount} value={this.state.portCount <= 0 ? '' : this.state.portCount} type="number"
					onChange={e => this.onFieldChange('portCount', e)} />
				<span className={customStyles.portCountLabel}>Количество портов:</span>

				<select className={customStyles.cableCategory} value={this.state.cableCategory} onChange={e => this.onFieldChange('cableCategory', e)}>
					<option value="">Категория кабеля:</option>
					<option value="5e">Кат 5E</option>
					<option value="6">Кат 6</option>
				</select>

				<select className={customStyles.cableShield} value={this.state.cableShield} onChange={e => this.onFieldChange('cableShield', e)}>
					<option value="">Наличие экрана:</option>
					<option value="y">Экранированный кабель</option>
					<option value="n">Неэкранированный кабель</option>
				</select>

				<span className={customStyles.totalCost}>{this.state.totalCost.toLocaleString()} &#8381;</span>

				<SpecList
					specList={this.state.specList}
					selected={this.state.item}
					onItemClick={this.onSpecListItemClick}
					onChangeItemVariant={this.onChangeItemVariant}
				/>

				<Image
					className={styles.preview}
					url={this.state.item && this.state.item.photo ? this.state.item.photo : null}
				/>

				<div className={this.state.item && this.state.item.description ? styles.descFilled : styles.desc}>
					{this.state.item && this.state.item.description ? this.state.item.description : null}
				</div>

				<Button
					buttonStyle={customStyles.btnPdf}
					buttonDisabledStyle={customStyles.btnPdfDisabled}
					iconStyle={customStyles.btnPdfIcon}
					text="Сохранить в PDF"
					textStyle={customStyles.btnPdfTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnPrintPdfClick}
				/>
				<Button
					buttonStyle={customStyles.btnExcel}
					buttonDisabledStyle={customStyles.btnExcelDisabled}
					iconStyle={customStyles.btnExcelIcon}
					text="Сохранить в Excel"
					textStyle={customStyles.btnExcelTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnExcelClick}
				/>
				<Button
					buttonStyle={customStyles.btnPrint}
					buttonDisabledStyle={customStyles.btnPrintDisabled}
					iconStyle={customStyles.btnPrintIcon}
					text="Распечатать"
					textStyle={customStyles.btnPrintTextStyle}
					//disabled={!this.state.item}
					onClick={this.onBtnPrintClick}
				/>
				<Button
					buttonStyle={styles.btnStepDownload}
					iconStyle={styles.btnDwgDownloadIcon}
					text="Скачать базу в формате STEP"
					onClick={this.onStepDownload}
				/>
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '713px'}}/>
				<a className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#76d750',
					width: '50%',
					height: '22px',
					top: '713px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '716px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		);
	}
}

class SpecList extends React.Component
{
	render() {
		return (
			<div className={styles.specList}>
				<table className={styles.specListTable}>
					<colgroup>
						<col width="95px" />
						<col width="188px" />
						<col width="79px" />
						<col width="72px" />
						<col width="95px" />
					</colgroup>
					<tbody>
						{this.props.specList.map((item, i) => {
							if (item.hidden) {
								return null;
							}

							return (
								item.article ? (
									<tr key={i} className={this.props.selected && this.props.selected.article === item.article ? styles.specListPointerRowSelected : styles.specListPointerRow} onClick={() => this.props.onItemClick(item)}>
										<td>{item.article}</td>
										<td>
											{item.variants ? (
												<select value={item.article} onChange={e => this.props.onChangeItemVariant(e.target.value, item)}>
													{item.variants.map(variantItem =>
														<option value={variantItem.article} key={variantItem.article}>{variantItem.name}</option>)}
												</select>
											) : (
												item.name
											)}
										</td>
										<td>{item.count}</td>
										<td>{item.price ? <span>{item.price.toLocaleString()} &#8381;</span> : ''}</td>
										<td>{item.price ? <span>{(item.price * item.count).toLocaleString()} &#8381;</span> : ''}</td>
									</tr>
								) : (
									<tr key={i} className={styles.specListSectionRow}>
										<td colSpan="5">{item.name}</td>
									</tr>
								)
							);
						})}
					</tbody>
				</table>
			</div>
		);
	}
}

export default ItkTenderConfigurator;



// WEBPACK FOOTER //
// ./src/react/ItkTenderConfigurator.jsx